import React, { FC } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';

import Text from '@/components/Text';
import { ALL_MOBILE_ROUTES, navigate } from '@/utils/navigation';

interface IExperienceResetPassword {
  setNeedUpdateFields?: (value: boolean) => void;
}

const ExperienceResetPassword: FC<IExperienceResetPassword> = ({ setNeedUpdateFields }) => {
  const { t } = useTranslation();

  const goToExperienceDemoResetPasswordScreen = () => {
    navigate(ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_RESET_PASSWORD, { setNeedUpdateFields });
  };
  return (
    <StyledLinkContainer>
      <StyledLinkButton onPress={goToExperienceDemoResetPasswordScreen}>
        <StyledLinkLabel>{t('Reset Password')}</StyledLinkLabel>
      </StyledLinkButton>
    </StyledLinkContainer>
  );
};

export default ExperienceResetPassword;

const StyledLinkContainer = styled.View`
  flex-direction: row;
  justify-content: center;
`;

const StyledLinkButton = styled.TouchableOpacity`
  margin-bottom: ${dynamicSize.convertSize(8)}px;
`;

const StyledLinkLabel = styled(Text)`
  font-size: ${dynamicSize.convertSize(14)}px;
  color: ${({ theme }) => theme.colors.primary};
`;
